import React from 'react'
import Burger from "./Burger/Burger"
import logo from "../../assets/Icon/adaya.png"
import styled from "styled-components"
import NavMenu from "./navMenu/NavMenu"


const Navbar = styled.div` 
  height: 65px;
  display: flex;
  background-color:white;
  width:100%;
  justify-content: space-between;
  -webkit-box-shadow: 2px 5px 10px 0px rgba(211, 211, 211, 1);
  -moz-box-shadow: 2px 5px 10px 0px rgba(211, 211, 211, 1);
  box-shadow: 2px 5px 10px 0px rgba(211, 211, 211, 1);
  z-index:5;
  position:fixed;

`

const Image = styled.img`
  width: 13em;
  cursor:pointer;
  padding:5px;
  `

const NavBar = () => {
  return (
<>
<Navbar>
    <Image src={logo} alt="Logo" onClick={() => window.scrollTo({top:0,left:0, behavior:"smooth"})} />
    <Burger />
    <NavMenu />
</Navbar>

</>
  )
}


export default NavBar

